const NAVER_WA = "s_40b92acec480";
const SITE_DOMAIN = "www.goifuneral.co.kr";

export const naverPageView = () => {
  if (!window.wcs_add) window.wcs_add = {};
  window.wcs_add["wa"] = NAVER_WA;
  if (!window._nasa) window._nasa = {};
  if (window.wcs) {
    window.wcs.inflow(SITE_DOMAIN);
    window.wcs_do(window._nasa);
  }
};

export const naverConversionEvent = ({
  type,
  value,
}: {
  type: "purchase" | "add_to_cart" | "sign_up" | "lead";
  // | "view_product"
  // | "view_content"
  // | "begin_checkout"
  // | "add_to_wishlist"

  value?: string;
}) => {
  if (window.wcs) {
    if (!window.wcs_add) window.wcs_add = {};

    window.wcs_add["wa"] = NAVER_WA;

    window.wcs.inflow(SITE_DOMAIN);

    let _conv;
    if (type === "purchase" && value) {
      _conv = { type, value };
    } else {
      _conv = { type };
    }

    window.wcs.trans(_conv); // 전환이벤트 정보를 담은 object를 서버에 전송(위 item #1, #2 포함)
  }
};
